

/*
 * import svg sprite
 * see webpack.mix file mix.svgSprite()
 */
function requireAllSvgs(r) {
  r.keys().forEach(r);
}
requireAllSvgs(require.context('../icons/', true, /\.svg$/));

// Hide the search heading (H2)
const searchH2 = document.querySelector(".search-form");

if (typeof(searchH2) != 'undefined' && searchH2 != null) {
  const elem = searchH2.nextElementSibling;
  elem.classList.add("hide-all");
}


// Includes
require('./components/navigation.js');
require('./components/search.js');
require('./components/truncate.js');
require('./components/modal.js');
require('./components/accordion.js');
require('./components/list.js');
require('./components/calendar.js');


var errorMessage = document.querySelector('.error-message');

if (errorMessage) {
  errorMessage.onclick = function (event) {
    errorMessage.classList.add('is-hidden');
  }
}

var seminarRegisterButton = document.querySelector("#seminar-button");
if (seminarRegisterButton) {
  seminarRegisterButton.onclick = function (event) {
  var Islogged = document.querySelector(".wer-user-loggedin")

    if (Islogged) {
      event.preventDefault();
      var infoBox = document.querySelector('.infobox__bottom');


      if (infoBox.classList.contains('is-active')) {
        infoBox.classList.remove('is-active');
      } else {
        infoBox.classList.add('is-active');
      }
    } else {
      window.location.href = "/profil";
    }

  };
}




var seminarsystemSwitch = document.querySelector('.dd-seminarsystem');
if (seminarsystemSwitch) {

  var seminarsystem_trigger = document.querySelector('.dd-seminarsystem__switch__item--1');
  var weiterbildung_trigger = document.querySelector('.dd-seminarsystem__switch__item--2');


  seminarsystem_trigger.onclick = function (event) {
    seminarsystemSwitch.classList.add('dd-seminarsystem--system-active');
    seminarsystemSwitch.classList.remove('dd-seminarsystem--weiter-active');
    seminarsystem_trigger.classList.add('is-active');
    weiterbildung_trigger.classList.remove('is-active');
  }

  weiterbildung_trigger.onclick = function (event) {
    seminarsystemSwitch.classList.remove('dd-seminarsystem--system-active');
    seminarsystemSwitch.classList.add('dd-seminarsystem--weiter-active');
    seminarsystem_trigger.classList.remove('is-active');
    weiterbildung_trigger.classList.add('is-active');
  }


}



var offerButtons = document.querySelectorAll('.dd-offer__buttons .file a');
offerButtons.forEach(function(button) { 
  button.setAttribute("target","_blank");
});

